// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/MajorList/index.less
// module id = 426
// module chunks = 0